export const PER_PAGE_OPTIONS = ["10", "20", "50"];

export const formatPrice = (value) =>
  `${Number(value ?? 0).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ₺`;

export const formatPriceCompact = (value) => {
  const amount = Number(value ?? 0);

  return amount >= 1000
    ? `${(amount / 1000).toLocaleString("tr-TR", { maximumFractionDigits: 1 })}b ₺`
    : `${amount.toLocaleString("tr-TR", { maximumFractionDigits: 0 })} ₺`;
};

// POS adetleri ondalıklı gelebiliyor (kiloyla satılan ürünler: 0,983). Ham float toplamı
// 6631.982999999999 gibi kuyruklar üretiyordu; iki basamak yeter, gereksiz sıfır yazılmıyor.
export const formatQuantity = (value) =>
  Number(value ?? 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });

// Tek günlük dönemler yalnız Ürün Satışları sekmesinde: "bugün ne sattık" oranın sorusu. Ciro
// ekranı dönem karşılaştırması yaptığı için tek güne inmiyor.
export const SALES_PERIODS = [
  { value: "today", label: "Bugün" },
  { value: "yesterday", label: "Dün" },
  { value: "week", label: "Hafta" },
  { value: "month", label: "Ay" },
  { value: "year", label: "Yıl" },
  { value: "custom", label: "Özel" },
];

export const REVENUE_PERIODS = [
  { value: "week", label: "Hafta" },
  { value: "month", label: "Ay" },
  { value: "year", label: "Yıl" },
  { value: "custom", label: "Özel" },
];

export const REVENUE_PERIOD_LABELS = {
  today: { current: "Bugün", previous: "düne göre" },
  yesterday: { current: "Dün", previous: "önceki güne göre" },
  week: { current: "Bu hafta", previous: "geçen haftaya göre" },
  month: { current: "Bu ay", previous: "geçen aya göre" },
  year: { current: "Bu yıl", previous: "geçen yıla göre" },
  custom: { current: "Seçili aralık", previous: "önceki eş aralığa göre" },
};

export const toIsoDay = (date) =>
  date instanceof Date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    : (date ?? null);

export const formatPeriodRange = (period, range) => {
  if (!range) {
    return "";
  }

  const from = new Date(`${range.from}T00:00:00`);

  if (period === "year") {
    return String(from.getFullYear());
  }

  if (period === "custom") {
    const to = new Date(`${range.to}T00:00:00`);
    const opts = { day: "numeric", month: "short", year: "numeric" };

    return `${from.toLocaleDateString("tr-TR", opts)} – ${to.toLocaleDateString("tr-TR", opts)}`;
  }

  if (period === "month") {
    return from.toLocaleDateString("tr-TR", { month: "long", year: "numeric" });
  }

  // Tek günlük dönemde iki uç aynı: "9 Ağu – 9 Ağu" yerine tek tarih yazılıyor.
  if (range.from === range.to) {
    return from.toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  const to = new Date(`${range.to}T00:00:00`);
  const short = { day: "numeric", month: "short" };

  return `${from.toLocaleDateString("tr-TR", short)} – ${to.toLocaleDateString("tr-TR", short)}`;
};

const BRANCH_COLORS = [
  "chocolate.6",
  "teal.7",
  "yellow.8",
  "indigo.5",
  "pink.6",
  "lime.9",
  "cyan.7",
  "grape.5",
];

const BRAND_HUE = 24;
const GOLDEN_ANGLE = 137.508;

export const branchColor = (index) =>
  index < BRANCH_COLORS.length
    ? BRANCH_COLORS[index]
    : `hsl(${Math.round((BRAND_HUE + index * GOLDEN_ANGLE) % 360)}, 45%, 58%)`;

const BAR_COLORS = [
  "#D2795A",
  "#4E9C86",
  "#DFA94E",
  "#6C7FC4",
  "#CC7392",
  "#87AE5F",
  "#5AA3B5",
  "#A279C0",
];

export const branchBarColor = (index) =>
  index < BAR_COLORS.length
    ? BAR_COLORS[index]
    : `hsl(${Math.round((BRAND_HUE + index * GOLDEN_ANGLE) % 360)}, 44%, 56%)`;
